import React, { useState, useEffect } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import css from './index.module.scss';
import { RoutableRichText } from '../../react/RoutableRichText';
import { useCookies } from 'react-cookie';
import { handleResizeFixedHeader } from '../../ts/handleResizeFixedHeader';
import '../../ts/polyfills';

const key = 'dismissed-alerts';
const tenYears = 10 * 365 * 24 * 60 * 60;

const Alert = (props) => {
  const { fields, sitecoreContext } = props;
  const [cookies, setCookie] = useCookies([key]);
  const [dismissed, setDismissed] = useState(cookies[key] || []);
  const isEditing = sitecoreContext && (sitecoreContext.pageEditing == true || sitecoreContext.pageState == 'preview');

  const alert = fields?.items.find(x => !dismissed.some(y => y.id === x.id));

  const dismiss = () => {
    const activeAlerts = dismissed.filter(x => new Date(x.endDate) > new Date());   // forget old alerts
    setDismissed([...activeAlerts, { id: alert.id, endDate: alert.fields.endDate.value }]);
  };

  useEffect(() => {
    setCookie(key, dismissed, { path: '/', maxAge: tenYears });
    // eslint-disable-next-line react-hooks/exhaustive-deps

    if (!isEditing) {
      handleResizeFixedHeader();      
    }    
  }, [dismissed]);

  return alert ?
    <section className={css.container}>
      <div className={`${css.containerInner} single-col-inner`}>
        <RoutableRichText field={alert.fields.description} className={css.richtext} />
        <button className={`${css.close} fa fa-close`}
          onClick={dismiss}
          data-id={alert.id}
          aria-label="Close Alert" 
          tab-index="0"
          />
      </div>
    </section>
    : null;
};

export default withSitecoreContext()(Alert);